const typographyTokens = {
  HeadingMBold: {
    color: "var(--tooltip-text-color, #15191E)", // Default or fallback color
    fontFamily: "NeueFrutigerWorld",
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "32px", // Line height in pixels
  },
  HeadingLBold: {
    color: "var(--notification-border-warning, #F27436)", // Default or fallback color
    fontFamily: "NeueFrutigerWorld",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "40px", // Line height in pixels
  },
  HeadingXLBold: {
    color: "var(--toggle-switch-track-background-selected-active, #0052A3)", // Default or fallback color
    fontFamily: "NeueFrutigerWorld",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "50px", // Line height in pixels
  },
  BodyL: {
    color: "var(--typography-color-primary, #15191E)",
    fontFamily: "NeueFrutigerWorld",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "350",
    lineHeight: "26px;" /* 144.444% */,
  },
};

export default typographyTokens;
